import { ReactNode, useEffect, useState } from "react"
import { useAppDispatch, useAppSelector } from "../../../../../lib/redux/hooks"
import { CarTypeEnum, PaymentTypeEnum, ReimbursementTypeEnum } from "./dataservice/dto"
import { GetIVReimbursementByInspectorCodeAndType, resetGetReimbursementByInspectorCodeAndTypeSAtatus, resetReimbursementCreationRequestButType, setReimbursementCreationAmount, setReimbursementCreationArrivalPlace, setReimbursementCreationCarModel, setReimbursementCreationCarNumberPlate, setReimbursementCreationCarType, setReimbursementCreationDay, setReimbursementCreationDeparturePlace, setReimbursementCreationInspectionVisitIds, setReimbursementCreationKilometresTravelled, setReimbursementCreationNote, setReimbursementCreationPaymentType, setReimbursementCreationReturnPlace, setReimbursementCreationUsedVehicle } from "./slice"
import Input from "../../../../../ui/molecules/input"
import { SingleCheckbox } from "../../../../../ui/molecules/SingleCheckbox"
import { CustomRadio } from "../../../../../ui/molecules/radioButton"
import { TableSelect } from "../../../../../ui/molecules/tableSelect"
import { GetAllInspectionVisit } from "../../../slice"
import { formatterDate, UsedVehicleOptions } from "../../../../../utils"
import { SelectCustom } from "../../../../../ui/molecules/select"
import TextArea from "../../../../../ui/molecules/textArea"
import { Calendar } from "../../../../../ui/molecules/calendar"
import { format } from "date-fns"

export function GestioneRimborsiContext() {
    const dispatch = useAppDispatch()
    const reimbursementState = useAppSelector(state => state.reimbursement)
    const assignmentState = useAppSelector(state => state.assignment)
    const [paymentType, setPaymentType] = useState<string | null>(null)
    const [carType, setCarType] = useState<string | null>(null)

    useEffect(() => {
        dispatch(GetAllInspectionVisit({
            itemsPerPage: 0,
            page: 0,
            assignmentId: assignmentState.assignmentIdToUpdate,
            inspectionVisitId: assignmentState.inspectionVisitIdToUpdate
        }))

        dispatch(GetIVReimbursementByInspectorCodeAndType({
            inspectorCode: assignmentState.getAssignmentByIdResponse?.inspectorCode!,
            type: ReimbursementTypeEnum.INDENNITA_CHILOMETRICA
        }))
    }, [])

    useEffect(() => {
        if (reimbursementState.getReimbursementByInspectorCodeAndTypeStatus === 'successfully' &&
            reimbursementState.getReimbursementByInspectorCodeAndTypeResponse
        ) {
            dispatch(resetGetReimbursementByInspectorCodeAndTypeSAtatus())
            const data = reimbursementState.getReimbursementByInspectorCodeAndTypeResponse
            dispatch(setReimbursementCreationCarModel(data.carModel))
            dispatch(setReimbursementCreationCarNumberPlate(data.carNumberPlate))
        }
    }, [reimbursementState.getReimbursementByInspectorCodeAndTypeStatus])

    useEffect(() => {
        dispatch(resetReimbursementCreationRequestButType())
    }, [reimbursementState.reimbursementCreationRequest.reimbursementType])

    if (reimbursementState.reimbursementCreationRequest.reimbursementType !== ReimbursementTypeEnum.INDENNITA_CHILOMETRICA)
        return (
            <div>
                {
                    reimbursementState.reimbursementCreationRequest.reimbursementType === ReimbursementTypeEnum.ALTRO && (
                        <div className="pb-5">
                            <div className="assignment-text-content text-left">
                                Mezzo usato
                            </div>
                            <SelectCustom
                                placeholder="Seleziona mezzo..."
                                options={UsedVehicleOptions}
                                value={reimbursementState.reimbursementCreationRequest.usedVehicle}
                                onChange={(value) => dispatch(setReimbursementCreationUsedVehicle(value))}
                            />
                        </div>
                    )
                }

                <div className="pb-5" style={{ display: 'flex', gap: '24px', alignItems: 'center' }}>
                    <div style={{ flex: '1' }}>
                        <div className="assignment-text-content text-left">
                            Importo
                        </div>
                        <Input
                            placeholder="Specifica importo..."
                            value={String(reimbursementState.reimbursementCreationRequest.amount ?? 0)}
                            type={'number'}
                            onChangeText={(text) =>
                                dispatch(
                                    setReimbursementCreationAmount(text)
                                )
                            }
                        />

                    </div>
                    <div className="pt-7" style={{ display: 'flex', gap: '16px', alignItems: 'center' }}>
                        <div style={{ display: 'flex', gap: '12px', alignItems: 'center' }}>
                            <CustomRadio
                                options={[{ label: '', value: '1' }]}
                                selectedValue={paymentType}
                                onChange={(value) => {
                                    setPaymentType(value)
                                    dispatch(setReimbursementCreationPaymentType(PaymentTypeEnum.TRACCIATO))
                                }}
                                id={'tracked'}
                                name={'tracked'}
                            />
                            <div className='text-left'>
                                <span className='assignment-text-content'>Pagamento tracciato (carta, bonifico, ecc.)</span>
                            </div>
                        </div>
                        <div style={{ display: 'flex', gap: '12px', alignItems: 'center' }}>
                            <CustomRadio
                                options={[{ label: '', value: '2' }]}
                                selectedValue={paymentType}
                                onChange={(value) => {
                                    setPaymentType(value)
                                    dispatch(setReimbursementCreationPaymentType(PaymentTypeEnum.NON_TRACCIATO))
                                }}
                                id={'not_tracked'}
                                name={'not_tracked'}
                            />
                            <div className='text-left'>
                                <span className='assignment-text-content'>Pagamento non tracciato (contanti)</span>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="pb-5">
                    <div className="assignment-text-content text-left">
                        Note
                    </div>
                    <TextArea
                        value={reimbursementState.reimbursementCreationRequest.note}
                        onChangeText={(text) => dispatch(setReimbursementCreationNote(text))}
                    />
                </div>

                <div>
                    <div className="assignment-subtitle text-left pb-3">
                        <span>Aggancia a visita</span>
                    </div>
                    <TableSelect
                        type="checkbox"
                        headers={['Data Visita', 'Operatore']}
                        data={assignmentState.getAllInspectionVisitResponse?.data.filter(iv => iv.id !== assignmentState.inspectionVisitIdToUpdate).map(iv => {
                            return {
                                value: iv.id,
                                labels: [formatterDate(iv.effectiveVisitDate), iv.customerCompanyName]
                            }
                        }) || []}
                        onChange={(value) => {
                            dispatch(setReimbursementCreationInspectionVisitIds([...value as string[], assignmentState.inspectionVisitIdToUpdate]))
                        }}
                    />
                </div>
            </div>
        )

    return (
        <div>
            <div className="assignment-subtitle text-left pb-5">
                Informazioni Automobile
            </div>

            <div className="pb-5" style={{ display: 'flex', gap: '24px', alignItems: 'center' }}>
                <div style={{ flex: '0.5' }}>
                    <div className="assignment-text-content text-left">
                        Modello Auto
                    </div>
                    <Input
                        value={reimbursementState.reimbursementCreationRequest.carModel}
                        placeholder="Specifica modello..."
                        onChangeText={(text) => dispatch(setReimbursementCreationCarModel(text))}
                    />
                </div>
                <div style={{ flex: '0.5' }}>
                    <div className="assignment-text-content text-left">
                        Targa Auto
                    </div>
                    <Input
                        placeholder="Specifica targa..."
                        value={reimbursementState.reimbursementCreationRequest.carNumberPlate}
                        onChangeText={(text) => dispatch(setReimbursementCreationCarNumberPlate(text))}
                    />
                </div>
            </div>

            <div className="pb-5" style={{ display: 'flex', gap: '16px', alignItems: 'center', borderBottom: '1px solid #d9e6e8' }}>
                <div style={{ display: 'flex', gap: '12px', alignItems: 'center' }}>
                    <CustomRadio
                        options={[{ label: '', value: '1' }]}
                        selectedValue={carType}
                        onChange={(value) => {
                            setCarType(value)
                            dispatch(setReimbursementCreationCarType(CarTypeEnum.AUTO_DI_PROPRIETA))
                        }}
                        id={'car_type_1'}
                        name={'car_type_1'}
                    />
                    <div className='text-left'>
                        <span className='assignment-text-content'>Auto di proprietà</span>
                    </div>
                </div>
                <div style={{ display: 'flex', gap: '12px', alignItems: 'center' }}>
                    <CustomRadio
                        options={[{ label: '', value: '2' }]}
                        selectedValue={carType}
                        onChange={(value) => {
                            setCarType(value)
                            dispatch(setReimbursementCreationCarType(CarTypeEnum.AUTO_A_NOLEGGIO))
                        }}
                        id={'car_type_2'}
                        name={'car_type_2'}
                    />
                    <div className='text-left'>
                        <span className='assignment-text-content'>Auto a noleggio</span>
                    </div>
                </div>
                <div style={{ display: 'flex', gap: '12px', alignItems: 'center' }}>
                    <CustomRadio
                        options={[{ label: '', value: '3' }]}
                        selectedValue={carType}
                        onChange={(value) => {
                            setCarType(value)
                            dispatch(setReimbursementCreationCarType(CarTypeEnum.AUTO_DELLA_SOCIETA))
                        }}
                        id={'car_type_3'}
                        name={'car_type_3'}
                    />
                    <div className='text-left'>
                        <span className='assignment-text-content'>Auto della società</span>
                    </div>
                </div>
            </div>

            <div className="assignment-subtitle text-left pb-5 pt-5">
                Altre Informazioni
            </div>

            <div className="pb-5" style={{ display: 'flex', gap: '24px', alignItems: 'center' }}>
                <div style={{ flex: '0.33' }}>
                    <div className="assignment-text-content text-left">
                        Giorno
                    </div>
                    <Calendar
                        selected={reimbursementState.reimbursementCreationRequest.day}
                        onChange={(date) => dispatch(setReimbursementCreationDay(format(new Date(date), 'yyyy-MM-dd')))}
                    />
                </div>
                <div style={{ flex: '0.33' }}>
                    <div className="assignment-text-content text-left">
                        Luogo di partenza
                    </div>
                    <Input
                        value={reimbursementState.reimbursementCreationRequest.departurePlace}
                        placeholder="Specifica luogo..."
                        onChangeText={(text) => dispatch(setReimbursementCreationDeparturePlace(text))}
                    />
                </div>
                <div style={{ flex: '0.33' }}>
                    <div className="assignment-text-content text-left">
                        Luogo di arrivo
                    </div>
                    <Input
                        placeholder="Specifica luogo..."
                        value={reimbursementState.reimbursementCreationRequest.arrivalPlace}
                        onChangeText={(text) => dispatch(setReimbursementCreationArrivalPlace(text))}
                    />
                </div>
            </div>

            <div className="pb-5" style={{ display: 'flex', gap: '24px', alignItems: 'center' }}>
                <div style={{ flex: '0.5' }}>
                    <div className="assignment-text-content text-left">
                        Luogo di ritorno
                    </div>
                    <Input
                        placeholder="Specifica luogo..."
                        value={reimbursementState.reimbursementCreationRequest.returnPlace}
                        onChangeText={(text) => dispatch(setReimbursementCreationReturnPlace(text))}
                    />
                </div>
                <div style={{ flex: '0.5' }}>
                    <div className="assignment-text-content text-left">
                        Km percorsi
                    </div>
                    <Input
                        placeholder="Specifica km..."
                        value={reimbursementState.reimbursementCreationRequest.kilometresTravelled}
                        onChangeText={(text) => dispatch(setReimbursementCreationKilometresTravelled(text))}
                    />
                </div>
            </div>

            <div className="pb-5">
                <div className="assignment-text-content text-left">
                    Note
                </div>
                <TextArea
                    value={reimbursementState.reimbursementCreationRequest.note}
                    onChangeText={(text) => dispatch(setReimbursementCreationNote(text))}
                />
            </div>
        </div>
    )
}